import { render } from "./ReferralRewards.vue?vue&type=template&id=3033a027&scoped=true"
import script from "./ReferralRewards.vue?vue&type=script&lang=js"
export * from "./ReferralRewards.vue?vue&type=script&lang=js"

import "./ReferralRewards.vue?vue&type=style&index=0&id=3033a027&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3033a027"]])

export default __exports__